const initState = {
    organisation: [],
    department: [],
    contact:[]
  };
  const dataReducers = (state = initState, action) => {
    switch (action.type) {
        case "ORGANIZATION_DATA":
            return { ...state,organisation:action.payload};
        case "DEPARTMENT_DATA":
            return {...state,department:action.payload}
        case "CONTACT_DATA":
            return {...state,contact:action.payload}

        // Lab category Data
        case "LABCATEGORY_DATA":
            return {...state,labCategory:action.payload}

        // Bloom Domain data
        case "BLOOM_DOMAIN_DATA":
            return {...state,bloomDomain:action.payload}

        // Bloom Domain Level
        case "BLOOM_LEVEL_DATA":
            return {...state,bloomLevel:action.payload}

        //DELIVERY_METHOD_DATA
        case "DELIVERY_METHOD_DATA":
            return {...state,deliveryMethod:action.payload}
        
        //MAP_LEVEL_WEIGHTAGE
        case "MAP_LEVEL_WEIGHTAGE":
            return {...state,mapLevelWeightage:action.payload}

        //PROGRAM_TYPE
        case "PROGRAM_TYPE":
            return {...state,programType:action.payload}

        //PROGRAM
        case "PROGRAM":
            return {...state,program:action.payload}

        //COURSE
        case "COURSE":
            return {...state,course:action.payload}

        //PROGRAM_MODE
        case "PROGRAM_MODE":
            return {...state,programMode:action.payload}

        //PROGRAM_OUTCOME
        case 'PROGRAM_OUTCOME':
            return {...state,programOutcome:action.payload}

        //QUESTION_BANK
        case 'QUESTION_BANK':
            return {...state,questionBank:action.payload}

        //COURSE_OUTCOME
        case 'COURSE_OUTCOME':
            return {...state,courseOutcome:action.payload}

        //TERMS
        case 'TERMS':
            return {...state,terms:action.payload}

        //CURRICULUM
        case 'CURRICULUM':
            return {...state,curriculums:action.payload}

        //COURSE_CURRICULUM
        case 'COURSE_CURRICULUM':
            return {...state,course_curriculum:action.payload}

        //STACKHOLDER
        case 'STACKHOLDER':
            return {...state,stackholder:action.payload}

        //SURVEY
        case 'SURVEY':
            return {...state,survey:action.payload}
        
        //TEMPLATE
        case 'TEMPLATE':
            return {...state,template:action.payload}

         //FACULTY_WORKLOAD
         case 'FACULTY_WORKLOAD':
            return {...state,Faculty_workload:action.payload}

        //RESEARCH_PUBLICATION
        case 'RESEARCH_PUBLICATION':
            return {...state,research_publication:action.payload}
        
         //SPONSORED_PROJECTS
         case 'SPONSORED_PROJECTS':
            return {...state,sponsored_projects:action.payload}

         //PATENT_INNOVATION
         case 'PATENT_INNOVATION':
            return {...state,patent_innovation:action.payload}

         //CONSULTING_PROJECTS
         case 'CONSULTING_PROJECTS':
            return {...state,consulting_projects:action.payload}

         //AWARD_HONOUR
         case 'AWARD_HONOUR':
            return {...state,award_honour:action.payload}

         //BOOK_PUBLISH
         case 'BOOK_PUBLISH':
            return {...state,book_publish:action.payload}

         //Book_CHAPTER
         case 'Book_CHAPTER':
            return {...state,book_chapter:action.payload}


         //FELLOWSHIP
         case 'FELLOWSHIP':
            return {...state,fellowship:action.payload}


         //WORKSHOP_ORGANIZED
         case 'WORKSHOP_ORGANIZED':
            return {...state,workshop_organized:action.payload}

         //WORKSHOP_ATTENDED
         case 'WORKSHOP_ATTENDED':
            return {...state,workshop_attended:action.payload}

         //RESEARCH_PROJECTS
         case 'RESEARCH_PROJECTS':
            return {...state,research_projects:action.payload}

         //PROFESSIONAL_BODIES
         case 'PROFESSIONAL_BODIES':
            return {...state,professional_bodies:action.payload}
        //Profile 
        case "PROFILE_DATA":
            return { ...state, profile:action.payload};

        // MANAGE_USER
        case "MANAGE_USER":
            return { ...state, users:action.payload};

        // DEPARTMENT_USER_LIST
        case "DEPARTMENT_USER_LIST":
            return { ...state, department_user:action.payload};

        //SEND_MAIL
        case "SEND_MAIL":
            return {...state,send_mail:action.payload};
        
        // TOPIC_LIST
        case "TOPIC_LIST":
            return {...state,topics:action.payload};

        // LAB_EXPERIMENT_LIST
        case "LAB_EXPERIMENT_LIST":
            return {...state,lab_experiment:action.payload};

        default:
            return state;
    }
  };
  export default dataReducers;
  